import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';
import { useEffect, useState } from "react"
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { useUserCart } from '../../../context/User/UserCartContext';
import { CountBadge } from '../../common/NumberBadge';

export default function HeaderCart() {
    const [isLogIn, setIsLogIn] = useState(false);
    const { i18n } = useTranslation();
    const { cartStats } = useUserCart();

    useEffect(() => {
        if (Cookies.get('token')) {
            setIsLogIn(true)
        }
    }, [isLogIn]);

    const CartCount = cartStats?.data?.totalBooks + cartStats?.data?.totalApprovedOrders;

    return (
        <>
            <Link className={`user-cart text-white bg-light-beige mx-1 ${i18n.language === "en" ? "en" : ""}`} type='button'
                to={isLogIn && `/${i18n.language}/myBasket`}>
                <FontAwesomeIcon icon={faCartShopping} className='align-middle fs-6' />
                {isLogIn && (CartCount >= 1 && <CountBadge itemCount={CartCount} />)}
            </Link>
        </>
    )
};



